import {SimpleGrid} from 'src/design/atoms/SimpleGrid';
import {Stack} from 'src/design/atoms/Stack';
import React from 'react';
import {Link} from 'react-router-dom';
import type {DirectoryCategory} from 'src/app/layout/Sidebar/components/SidebarLinks';
import {useVisibleSidebarLinks} from 'src/app/layout/Sidebar/useVisibleSidebarLinks';
import {Subtitle} from 'src/design/atoms/Typography';
import {NavCard} from 'src/design/molecules/NavCard';

export interface DirectoryCategoriesProps {
  categories: DirectoryCategory[];
}

const DirectoryCategorySection: React.FC<{category: DirectoryCategory}> = ({
  category,
}) => {
  const links = React.useMemo(
    () => category.entries.map(entry => entry.link),
    [category]
  );
  const visibleLinks = useVisibleSidebarLinks(links);
  const entries = category.entries.filter(entry =>
    visibleLinks.includes(entry.link)
  );

  if (entries.length === 0) return null;

  return (
    <Stack gap="md">
      <Subtitle text={category.title} />
      <SimpleGrid cols={{base: 1, sm: 2, lg: 3}}>
        {entries.map(entry => (
          <NavCard
            key={entry.link.path}
            component={Link}
            to={entry.link.path}
            title={entry.link.name}
            description={entry.description}
            icon={entry.link.icon}
          />
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export const DirectoryCategories: React.FC<DirectoryCategoriesProps> = ({
  categories,
}) => (
  <Stack gap="lg">
    {categories.map(category => (
      <DirectoryCategorySection key={category.title} category={category} />
    ))}
  </Stack>
);
